import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { LogicRoute } from 'sitemap';

interface NavItemProps {
  route: LogicRoute;
}

const NavItem = ({ route }: NavItemProps) => {
  return (
    <Nav.Item as="li">
      <NavLink
        to={route.path || '#!'}
        className={({ isActive }) =>
          classNames('nav-link', {
            active: isActive && route.path !== '#!'
          })
        }
      >
        <div className={classNames('d-flex align-items-center py-2')}>
          {route.icon && (
            <>
              <FontAwesomeIcon icon={route.icon} transform={{ size: 20 }} />
            </>
          )}
        </div>
      </NavLink>
    </Nav.Item>
  );
};

export default NavItem;
